/**
 * 2 行目はアプリの 1 行目（グルーピングシートの値名）に塗色記号が無いので handle 末尾から作る。
 * 要素は足さず `data-mrn-lo-sub` + CSS の `::after` で描く。アプリは `.lv-option-dropdown-value` の
 * textContent から aria-label を作るので子要素だと読み上げが二重になり、選択時に上書きもされる。
 */
(function () {
  'use strict';

  /** 2 行目の描画元（CSS の attr() が読む）。 */
  var SUB_ATTR = 'data-mrn-lo-sub';

  /** 表示中の product の handle。セクションが Liquid の `product.handle` を入れる。
   *  現行は redirect モード＝木部を選ぶと別 product の URL へ遷移するのでこの属性は常に新しいが、
   *  ページ遷移を伴わない切替が有効になると、古いままトリガーだけ差し替わりうる。 */
  var HANDLE_ATTR = 'data-mrn-lo-handle';

  /** handle 末尾の塗色記号を掴む。`-[英字1〜2]-[数字1桁]` に限るのは、緩めると分割商品以外の
   *  handle 末尾（`en-round-table-125` 等）を記号と誤認するため。桁数の違う記号が増えたら広げる
   *  （広げるまでは 2 行目が出ないだけで落ちない）。 */
  var HANDLE_CODE_RE = /-([a-z]{1,2}-\d)$/;

  /** 選択肢の行（別 product）の handle の在りか。どの属性に入るかは実機未確認なので、handle そのものが
   *  入る場合と商品 URL が入る場合の候補を順に見る。どれも無ければ 2 行目を出さない。 */
  var ROW_HANDLE_ATTRS = [
    'data-handle',
    'data-product-handle',
    'data-url',
    'data-product-url',
    'data-href',
    'href'
  ];

  /** handle から 2 行目の塗色記号を作る。形が違えば null（1 行のまま）。 */
  function codeFromHandle(handle) {
    var m = HANDLE_CODE_RE.exec((handle || '').trim().toLowerCase());
    return m ? m[1].toUpperCase() : null;
  }

  /** 属性値から handle を取る。`/products/<handle>` を含む URL か、handle そのもの。 */
  function handleFromAttr(value) {
    var v = (value || '').trim();
    if (!v) return null;
    var m = /\/products\/([^/?#]+)/.exec(v);
    if (m) return decodeURIComponent(m[1]);
    // パス・クエリ・空白を含まない＝handle そのものとして扱う
    return /^[^\s/?#]+$/.test(v) ? v : null;
  }

  /** 要素が持つ候補属性から handle を取る。どれも無ければ null。 */
  function handleFromElement(el) {
    if (!el || !el.getAttribute) return null;
    for (var i = 0; i < ROW_HANDLE_ATTRS.length; i++) {
      var handle = handleFromAttr(el.getAttribute(ROW_HANDLE_ATTRS[i]));
      if (handle) return handle;
    }
    return null;
  }

  /** 行の要素（と行の中の要素）から選択肢の商品 handle を探す。 */
  function rowHandle(row) {
    var found = handleFromElement(row);
    if (found) return found;
    var nodes = row.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      found = handleFromElement(nodes[i]);
      if (found) return found;
    }
    return null;
  }

  /** 2 行目を属性へ入れる（トリガーだけ塗装を前置きする）。
   *  値が変わらないときは書かない（MutationObserver を無駄に起こさないため）。 */
  function decorate(el, code, coating) {
    var sub = code ? (coating ? coating + ' / ' + code : code) : '';
    if (!sub) {
      if (el.hasAttribute(SUB_ATTR)) el.removeAttribute(SUB_ATTR);
      return;
    }
    if (el.getAttribute(SUB_ATTR) !== sub) el.setAttribute(SUB_ATTR, sub);
  }

  /** `名前=ラベル|名前=ラベル` を { 名前: ラベル } にする。壊れた対は捨てる。
   *  prototype を持たないオブジェクトにする（`constructor` 等のラベル名が
   *  Object.prototype のプロパティに当たって誤変換されないため）。 */
  function parseLabelMap(text) {
    var map = Object.create(null);
    (text || '').split('|').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i <= 0) return;
      var key = pair.slice(0, i).trim();
      var label = pair.slice(i + 1).trim();
      if (key && label) map[key] = label;
    });
    return map;
  }

  /** ラベルの文字だけ辞書に通す。辞書に無ければそのまま。
   *  書き換えは変化があるときだけ（MutationObserver が自分の書き換えで回り続けないため）。
   *  アプリが再描画で元の名前に戻しても、observer 経由でまた通る。 */
  function relabel(el, labelMap) {
    var src = el.textContent.trim();
    var label = labelMap[src];
    if (label && label !== src) el.textContent = label;
  }

  function apply() {
    var anchor = document.querySelector('.linked-option-variants-container');
    var coating = anchor ? anchor.getAttribute('data-mrn-lo-coating') || '' : '';
    var labelMap = parseLabelMap(anchor ? anchor.getAttribute('data-mrn-lo-label-map') : '');
    var currentCode = codeFromHandle(anchor ? anchor.getAttribute(HANDLE_ATTR) : '');

    // ラベル（セクション内）。データ名 → 画面ラベル
    document
      .querySelectorAll('#king-linked-options-section .lv-option-label__name')
      .forEach(function (el) {
        relabel(el, labelMap);
      });

    // トリガー（セクション内に残る）。表示中の product の記号に塗装を前置きする
    document
      .querySelectorAll('#king-linked-options-section .lv-option-dropdown > .lv-option-dropdown-item .lv-option-dropdown-value')
      .forEach(function (el) {
        decorate(el, currentCode, coating);
      });

    // 行（開くと <body> 直下のポップオーバーへ移るため、セクションで絞らない）。
    // 記号は行ごとに別 product なので、その行が持つ handle から作る。アプリが行の要素を使い回して
    // テキストだけ差し替えたときに古い記号が残らないよう、付いているかは見ずに毎回引き直す。
    document.querySelectorAll('.lv-option-dropdown-option').forEach(function (row) {
      var code = codeFromHandle(rowHandle(row));
      row.querySelectorAll('.lv-option-dropdown-value').forEach(function (el) {
        decorate(el, code, '');
      });
    });
  }

  // アプリの描画完了イベント（`linked_options_variants.min.js` が document に投げる）
  document.addEventListener('king-linked-option-product-loaded', apply);

  // 行はドロップダウンを開いた瞬間に生成され、値を選ぶとトリガーのテキストが差し替わる。
  // アプリの上書きは `innerText` 代入＝テキストノードの差し替えなので childList で拾える。
  // characterData はページ全体のテキスト変化を監視することになるため付けない。
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }).observe(document.body, { childList: true, subtree: true });

  apply();

  /* ---- 木部を変えて別 product へ移るときの合図 ----
     木部を選ぶと別 product の URL へ遷移し、生地・脚素材の選択が URL から落ちる。選択を控える・
     戻すのはテーマ側（maruni-product.js）の仕事なので、ここは知らせるだけに留める。 */

  function notifyBeforeSwitch(e) {
    var row = e.target && e.target.closest ? e.target.closest('.lv-option-dropdown-option') : null;
    if (!row) return;
    // 選択中の行でも知らせる。アプリは選択中の行を選び直したときも同じ product の素の URL へ
    // 遷移させるため、控えないと選択が先頭の値に戻る。handle を添えるのは、遷移しなかったときの
    // 控えを別の商品へ持ち込まないため。
    document.dispatchEvent(
      new CustomEvent('mrn:linked-option:before-switch', { detail: { handle: row.dataset.handle || '' } })
    );
  }

  // capture で受ける: アプリのハンドラが伝播を止めても、遷移を始める前に必ず通る
  document.addEventListener('click', notifyBeforeSwitch, true);
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Enter' || e.key === ' ') notifyBeforeSwitch(e);
    },
    true
  );
})();
